<template>
  <data-table
      :headers="headers"
      :items="codes"
      :options.sync="options"
      :server-items-length="total"
      @click:row="onRowClicked"
  >
    <template v-slot:item.type="{ item }">
      {{ getCodeTypeText(item) }}
    </template>
    <template v-slot:item.status="{ item }">
      {{ getCodeStatusText(item) }}
    </template>
    <template v-slot:item.createdAt="{ item }">
      {{ localDateTime(item.createdAtDto) }}
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
          small
          :disabled="!!item.processed"
          @click="deleteCode(item, $event)"
          title="Oznacz w bazie jako usunięty."
      >
        mdi-delete
      </v-icon>
    </template>
  </data-table>
</template>

<script>
import api from "@/services/api";
import DataTable from "@/components/data-table/DataTable";
import { getStatusText as getCodeStatusText } from '@/enums/CodeStatus';
import { getTypeText as getCodeTypeText } from '@/enums/CodeType';
import filters from "@/mixins/filters";
import formatters from "@/mixins/formatters";
import {getDatatableParams, setDatatableOptions} from "@/utils/helpers";

export default {
  mixins: [
    filters,
    formatters,
  ],
  components: {
    DataTable,
  },
  data() {
    return {
      loading: false,
      total: 0,
      codes: [],
      options: {},
      headers: [
        {text: 'Kod', value: 'code', sortable: false},
        {text: 'Typ', value: 'type', sortable: false},
        {text: 'NIP', value: 'nip', sortable: false},
        {text: 'Maks. ilość firm', value: 'maxCompanies', sortable: false},
        {text: 'Status', value: 'status', sortable: false},
        {text: 'Utworzony', value: 'createdAt', sortable: false},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      filters: {},
    };
  },
  created() {
    getDatatableParams.call(this);
    this.load();
  },
  mounted() {
    const self = this;

    this.$root.$on('loadCodes', (options) => {
      self.load(options);
    });
  },
  computed: {},
  watch: {
    options: {
      handler() {
        this.load();
        setDatatableOptions.call(this);
      },
      deep: true,
    },
  },
  methods: {
    deleteCode(item, event) {
      // The following line is required to avoid triggering onRowClicked() method.
      event.cancelBubble = true;

      if (item.processed) {
        return;
      }

      const code = item.code;
      const $icon = event.target;
      item.processed = true;
      $icon.disabled = true;
      $icon.classList.add('v-icon--disabled');

      api.delete(`/api/codes/${code}`)
          .then(() => {
            this.codes = this.codes.filter((item) => code !== item.code);
            this.$root.$emit('notifySuccess', {
              html: `Kod "${code}" został usunięty.`,
            });
          })
          .catch((error) => {
            $icon.disabled = false;
            $icon.classList.remove('v-icon--disabled');
            this.$root.$emit('notifyError', {
              html: 'Nie udało się usunąć kodu.',
              error,
            });
          })
          .finally(() => {
            delete item.processed;
          });
    },
    load(options = {}) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      options = options || {};

      let filters = {};
      this.appendFilters(filters, options.filters || this.filters);
      this.filters = filters; // Remember them.

      const {page, itemsPerPage} = this.options;
      const params = {
        ...filters,
        offset: page > 1 ? itemsPerPage * (page - 1) : 0,
      };

      if (-1 !== itemsPerPage) {
        params.limit = itemsPerPage;
      }

      api.get('/api/codes', {params})
          .then((response) => {
            this.codes = response.data.items;
            this.total = response.data.total;

            if (options.onSuccess) {
              options.onSuccess();
            }
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się pobrać listy kodów.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onRowClicked(details) {
      this.$router
          .push({
            name: 'codes-details', params: {
              code: details.code,
            }
          })
          .catch(() => {
          });
    },
    getCodeStatusText(item) {
      return getCodeStatusText(item.status);
    },
    getCodeTypeText(item) {
      return getCodeTypeText(item.type);
    },
    appendFilters(params, filters) {
      if (!(filters instanceof Object)) {
        return;
      }

      this.appendStringFilterIfNonEmpty(params, 'code', filters.code, 2);
      this.appendStringFilterIfNonEmpty(params, 'nip', filters.nip, 3);
      this.appendStringFilterIfNonEmpty(params, 'status', filters.status);
    },
  }
}
</script>